var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M18.629 3.61377C18.0896 3.14445 17.3796 2.93822 16.6852 3.05016C15.9892 3.16137 15.3832 3.57263 15.0228 4.17747C14.8183 4.52097 14.7034 4.91164 14.6907 5.30717C14.6653 6.0819 14.4476 6.72354 14.0448 7.21582L10.9221 11.0527C11.2676 11.0636 11.6237 11.0711 12 11.0711C13.6831 11.0711 15.0589 10.954 16.1197 10.7916L16.8551 8.99319C17.1243 8.33643 17.6021 7.79393 18.2008 7.46674C18.7118 7.18671 19.1031 6.72348 19.3015 6.1622C19.6197 5.2648 19.3493 4.24028 18.629 3.61377Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M18.3472 8.11117C17.9761 8.35486 17.6753 8.70512 17.4806 9.12583C18.596 9.39796 19.2767 9.75281 19.2767 10.1421C19.2767 10.9972 16.0188 11.6904 12.0001 11.6904C7.98127 11.6904 4.72339 10.9972 4.72339 10.1421C4.72339 9.2871 7.98127 8.59391 12.0001 8.59391C12.0419 8.59391 12.0823 8.5951 12.1239 8.5952L13.1154 7.37731C12.749 7.36405 12.3782 7.35533 12.0001 7.35533C6.86965 7.35533 2.71069 8.60304 2.71069 10.1421C2.71069 14.2515 4.56501 17.2086 7.66502 18.5768V19.1309C7.66502 19.8149 8.12645 20.4125 8.78749 20.5842C9.80106 20.8467 10.8818 20.9797 12.0001 20.9797C13.1183 20.9797 14.199 20.8467 15.2126 20.5842C15.8737 20.4125 16.3351 19.8149 16.3351 19.1309V18.5768C19.4351 17.2087 21.2894 14.2516 21.2894 10.1421C21.2894 9.34026 20.1541 8.61961 18.3472 8.11117ZM4.41251 13.279C4.38139 13.1839 4.47299 13.093 4.56748 13.1257C5.0415 13.2895 5.55061 13.4291 6.07783 13.5494C6.23704 13.5857 6.36209 13.7092 6.40384 13.8671C6.8279 15.4707 7.52542 16.7247 8.45932 17.5794C6.48042 16.8096 5.08671 15.3364 4.41251 13.279Z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }